import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

const ConfirmationDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    isDanger,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl">
                <div className="p-6">
                    <div className="flex items-center gap-3">
                        <div className={`rounded-full p-2 ${isDanger ? "bg-red-100" : "bg-amber-100"}`}>
                            <FiAlertTriangle
                                className={isDanger ? "text-red-600" : "text-amber-600"}
                                size={24}
                            />
                        </div>
                        <h3 className="text-xl font-bold text-[#173B3A]">{title}</h3>
                    </div>

                    <p className="mt-4 text-sm leading-6 text-gray-600">{message}</p>

                    <div className="mt-6 flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50"
                        >
                            انصراف
                        </button>
                        <button
                            onClick={onConfirm}
                            className={`flex-1 rounded-lg px-4 py-2 text-sm font-medium text-white transition ${
                                isDanger
                                    ? "bg-red-600 hover:bg-red-700"
                                    : "bg-teal-700 hover:bg-teal-800"
                            }`}
                        >
                            {confirmText || "تأیید"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDialog;